<template>
  <v-dialog v-model="show" max-width="650">
    <v-card>
      <v-icon class="close" @click="closeModal">close</v-icon>
      <v-card-title class="justify-center">Email sending</v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-text-field type="email" placeholder="e-mail" v-model="email" :rules="rules.emailRules"></v-text-field>
          <v-text-field type="text" placeholder="topic" v-model="subject"></v-text-field>
          <v-textarea v-model="message" placeholder="message"></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="purple" dark outline @click="closeModal">cancel</v-btn>
          <v-btn type="submit" color="purple" dark @click.prevent="submit">send</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <showModal
      v-model="showDialog"
      :message="dialogMessage"
      :header="dialogHeader"
      :buttonText="dialogButtonText"
    ></showModal>
  </v-dialog>
</template>

<script>
import axios from "axios";
import showModal from "@/components/ShowModal";

export default {
  name: "sendEmail",

  components: {
    showModal,
  },

  data: () => ({
    showDialog: false,
    dialogMessage: "",
    dialogHeader: "",
    dialogButtonText: "",
    show: true,
    email: "",
    subject: "Activation",
    message: "Your device id: ",
    rules: {
      emailRules: [
        value => !!value || "E-mail is required",
        value => /.+@.+/.test(value) || "E-mail must be valid"
      ]
    }
  }),

  methods: {
    closeModal() {
      this.$router.go(-1);
    },
    submit() {
      if (this.$refs.form.validate()) {
        let formData = new FormData();
        formData.append("email", this.email);
        formData.append("merchant_id", "");
        formData.append("device_id", this.$route.params.device_id);
        formData.append("subject", this.subject);
        formData.append("message", this.message);
        axios
          .post(this.$hostname + "/admin/send_email", formData, {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          })
          .then(response => {
            console.log(response);
            this.showError("Email was successfully sent!", 'ok');
            // this.closeModal();
          })
          .catch(error => {
            this.showError("Technical issues, please try one more time.", 'Try now!');
          });
      }
    },
    showError(message, buttonText) {
      this.showDialog = true;
      this.dialogMessage = message;
      this.dialogButtonText = buttonText;
    }
  },

  // created() {
  //   this.message = "Your device id:" + this.$route.params.device_id;
  //   this.subscription = { value: this.$route.params.subscription };
  //   this.message = "Your device id: ";
  //   if (this.$route.params.subscription === "false") {
  //     this.subscription = false;
  //   } else {
  //     this.subscription = true;
  //   }
  // },

  watch: {
    show(value) {
      if (!value) {
        this.closeModal();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card__title {
  font-size: 20px;
}

.v-form {
  padding: 0 80px 30px;
}

.v-icon.close {
  position: absolute;
  cursor: pointer;
  top: 10px;
  right: 10px;
}
</style>
